export class MFATokenRequestModel
{
    emailAddress!: string;
    password!: string;
    clientId!: string;
    sourceClientId!:string;
    mfaToken!:string;
}